import { FieldId } from '../../gk-dynamic-list/services/dictionary/dictionary.model';

export class DistrictGusFieldFromApi {
  constructor(
    public PowiatId: FieldId,
    public WojewId: FieldId,
    public Nazwa: string,
  ) {}
}

export class DistrictGusField {
  constructor(
    public id: FieldId,
    public name: string,
    public voivodeshipId: FieldId,
  ) {}

  static fromApiToApp(fieldFromApi: DistrictGusFieldFromApi): DistrictGusField {
    return new this(
      fieldFromApi.PowiatId,
      fieldFromApi.Nazwa,
      fieldFromApi.WojewId,
    );
  }
}
